module.exports = __webpack_public_path__ + "img/csa_button_snazzyclimb.d1ccb1fc.png";